<template>
  <div class="checkpoint-prep-note-input">
    <label class="checkpoint-prep-note-input__label" for="checkpoint-prep-note-input-textarea">
      Short instructions to employee (Optional)
    </label>
    <textarea
      id="checkpoint-prep-note-input-textarea"
      class="checkpoint-prep-note-input__textarea"
      data-testid="checkpoint-prep-note-input"
      :value="modelValue"
      :placeholder="placeholder"
      :readonly="readonly"
      :aria-readonly="String(readonly)"
      :tabindex="readonly ? -1 : undefined"
      rows="3"
      @input="handleInput"
      @mousedown="handleMouseDown"
      @focus="handleFocus"
    ></textarea>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "Enter simple instructions for the employee to prepare for inspection …",
  },
});

const emit = defineEmits(["update:modelValue"]);

function handleInput(event) {
  if (props.readonly) return;
  emit("update:modelValue", event.target.value);
}

function handleMouseDown(event) {
  if (props.readonly) {
    event.preventDefault();
  }
}

function handleFocus(event) {
  if (props.readonly) {
    event.target.blur();
  }
}
</script>

<style scoped>
.checkpoint-prep-note-input {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.checkpoint-prep-note-input__label {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
}

.checkpoint-prep-note-input__textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #101828;
  background-color: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  resize: vertical;
}

.checkpoint-prep-note-input__textarea::placeholder {
  color: #667085;
}

.checkpoint-prep-note-input__textarea:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 1px;
}

.checkpoint-prep-note-input__textarea[readonly] {
  color: #475467;
  background-color: #f9fafb;
  cursor: default;
  resize: none;
}

.checkpoint-prep-note-input__textarea[readonly]:focus,
.checkpoint-prep-note-input__textarea[readonly]:focus-visible {
  outline: none;
}
</style>
